import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles({
  mt: {
    marginTop: '9px',
  },
  mb: {
    marginBottom: '9px',
  },
  tableHeader: {
    fontWeight: 600,
  },
  tableCell: {
    padding: '4px',
  },
  disabledTableCell: {
    padding: '4px',
    color: 'red',
    disabled: true,
    pointerEvents: 'none',
  },
  checkBox: {
    color: '#0A688D !important',
  },
  disabledCheckbox: {
    color: '#797979',
    disabled: true,
    pointerEvents: 'none',
  },
  sendIcon: {
    fontSize: '26px',
    margin: '0 0.2rem',
  },
  receiveSlidesButton: {
    marginTop: '0px',
    marginLeft: '20px',
  },
  loadBalancerButton: {
    marginTop: '0px',
    marginRight: '10px',
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  sendSlidesButton: {
    // left: '0px',
    // position: 'absolute',
    // marginLeft: '1198px',
    marginTop: '-6px',
  },
  receivePathologistsSlidesButton: {
    marginLeft: '893px',
    marginTop: '-6px',
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'center',
  },
  btn: {
    backgroundColor: '#0A688D',
    color: '#fff',
    float: 'right',

    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
  buttonActions: {
    width: '100%',
    bottom: '0',
    left: '0',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
  },
  inlineMessage: {
    height: '60px',
    overflow: 'hidden',
  },
  error: {
    color: '#d32f2f',
  },
  success: {
    color: '#2e7d32',
  },
  loadingIndicator: {
    width: '30px',
    marginLeft: '20px',
    marginTop: '20px',
    height: '30px',
  },
  searchBox: {
    width: '290px',
    borderColor: '#0a688d',
    borderRadius: '8px',
    borderStyle: 'solid',
    backgroundColor: '#0a688d',
    height: '43px',
    marginTop: '-47px',
    marginLeft: '190px',
  },
  searchInput: {
    width: '246px',
    backgroundColor: 'white',
    fontSize: '14px',
    height: '38px',
    borderRadius: '3px',
    paddingLeft: '8px',
    textAlign: 'left',
  },
  searchIcon: {
    width: '30px',
    height: '30px',
    marginTop: '10px',
    color: 'white',
    boxSizing: 'border-box',
    backgroundColor: '#0a688d',
    cursor: 'pointer',
    marginLeft: '15px',
  },
  searchIconBox: {
    marginLeft: '237px',
    marginTop: '-43px',
  },
  searchTitle: {
    color: '#0A688D',
  },
  closeSearch: {
    marginLeft: '228px',
    position: 'absolute',
    marginTop: '-40px',
    cursor: 'pointer',
    color: '#0A688D',
  },
  saveButton: {
    width: '144px',
    height: '40px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    backgroundColor: '#0a688d',
    boxSizing: 'border-box',
    color: '#ffffff',
    textAlign: 'center',
    float: 'right',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
    },
  },
  disableBtn: {
    width: '144px',
    height: '40px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    backgroundColor: '#797979',
    color: '#fff !important',
    boxSizing: 'border-box',
    textAlign: 'center',
    float: 'right',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#797979',
      color: '#fff',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#797979',
      color: '#fff',
    },
  },
  reportFullPreview: {
    width: '100%',
  },
  reportHalfPreview: {
    width: '60%',
  },
  validationListItem: {
    padding: '0px',
    height: '20px',
    marginTop: '10px',
  },
  previewDialogHeight: {
    height: '100%',
    overflowY: 'hidden',
    width: '620px',
  },
  amendDialogHeight: {
    height: '100%',
    overflowY: 'hidden',
    width: '100%',
  },
  disableApplyBtn: {
    height: '40px',
    borderRadius: '5px',
    backgroundColor: '#797979',
    color: '#fff !important',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    zIndex: '999',
    '&:hover': {
      backgroundColor: '#797979',
    },
    float: 'right',
  },
  enableApplyBtn: {
    height: '40px',
    borderRadius: '5px',
    cursor: 'default',
    zIndex: '999',
    float: 'right',
  },
  errorMessage: {
    color: 'red',
    fontSize: '13px',
  },
  successMessage: {
    color: 'green',
    fontSize: '13px',
  },
})
